import React, { useState } from 'react';
import { FcGoogle } from 'react-icons/fc';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { auth } from './firebase';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      navigate("/sass", { replace: true });
    } catch (error) {
      toast.error(error.message, { position: "top-right" });
    }
  };

  async function googleLogin() {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider).then((result) => {
      navigate("/sass", { replace: true });
    }).catch((error) => {
      toast.error(error.message, { position: "top-right" });
    });
  }

  return (
       <section className="w-full min-h-screen flex overflow-hidden bg-gray-900">
        <div className="lg:w-2/5 w-full bg-gradient-to-b from-blue-950 to-teal-900 text-white flex items-center justify-center">
          <div className="w-full max-w-md p-8">
            <div className="flex justify-center mb-6">
              <img src="/images/walle.png" alt="logo" width={160} height={55} />
            </div>
            <p className="text-center text-gray-300 mb-6 lg:block hidden">Login to access your account</p>
            <form className="space-y-6" onSubmit={handleLogin}>
              <div>
                <label htmlFor="email" className="text-gray-300">Email</label>
                <input type="email" name="email" id="email" className="w-full p-3 border-2 border-gray-600 rounded-lg focus:ring-2 focus:ring-teal-300 text-gray-900 placeholder-gray-400" placeholder="name@gmail.com" required onChange={(e) => setEmail(e.target.value)} />
              </div>
              <div>
                <label htmlFor="password" className="text-gray-300">Password</label>
                <input type="password" name="password" id="password" placeholder="••••••••" className="w-full p-3 border-2 border-gray-600 rounded-lg focus:ring-2 focus:ring-teal-300 text-gray-900 placeholder-gray-400" required onChange={(e) => setPassword(e.target.value)} />
              </div>
              <button type="submit" className="w-full py-3 mt-4 bg-blue-700 text-white rounded-lg shadow-lg font-bold transition duration-200">Login</button>
              <div className="flex items-center justify-center my-4">
                <hr className="w-1/4 border-gray-300" />
                <span className="mx-4 text-sm text-gray-300">or</span>
                <hr className="w-1/4 border-gray-300" />
              </div>
            </form>
            <button onClick={googleLogin} type="button" className="w-full py-3 mt-2 bg-black text-white rounded-lg shadow-lg font-bold transition duration-200 flex items-center justify-center">
              <FcGoogle className="w-5 h-5 mr-2" />
              Continue with Google
            </button>
            <div className="text-center mt-4">
              <p className="text-sm text-white">
                Don't have an account? 
                <span className="text-white cursor-pointer" onClick={() => navigate("/Credentials")}> Sign up</span>
              </p>
            </div>
          </div>
        </div>
        <div className="hidden lg:block lg:w-3/5 relative">
          <img src="https://img.freepik.com/premium-photo/space-suit-with-space-suit-it_1208742-883.jpg?semt=ais_hybrid" className="w-full h-full object-cover opacity-95" alt="Login visual" />
          <div className="absolute inset-0 bg-gradient-to-t from-transparent to-gray-900 opacity-40"></div>
        </div>
      </section>
  );
};

export default Login;
